<template>
  <div class="home">
      <section class="section">
      <div class="container" v-if="$root.env.home.view == 'home'">
        <EventList />
      </div>

      <div class="container" v-if="$root.env.home.view == 'settings'">
        <Settings />
      </div>
    </section>

  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import EventList from '@/components/Home/EventList.vue'
import Settings from '@/components/Home/Settings.vue'

export default {
  name: 'home',
  components: {
    EventList,
    Settings,
    Navbar
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.$root.getEvents()
    this.$root.getSettings()
  }
}
</script>

<style scoped>



</style>

